export class DbConnectionSettings {
  public url: string;
  public headers: {
    Authorization: string;
  };

  constructor(
    url: string,
    username: string,
    password: string,
  ) {
    this.url = url;
    this.headers = this.getHeaders(
      username,
      password,
    );
  }

  private getHeaders(username: string, password: string) {
    const authHeader = Buffer.from(
      `${username}:${password}`,
    ).toString('base64');
    return {
      Authorization: `Basic ${authHeader}`,
    };
  }
}
